/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

const distanceInWords = require('date-fns/distance_in_words');

const filter = () =>
  function (timeStringOrTimestamp) {
    const now = Date.now();
    const timestamp =
      typeof timeStringOrTimestamp === 'number'
        ? timeStringOrTimestamp * 1000
        : timeStringOrTimestamp;

    return `${distanceInWords(timestamp, now)} ago`;
  };
module.exports = filter;
